module.exports = __webpack_public_path__ + "static/media/logo.5b1dd5bd.png";